import 'dayjs/locale/ja';

import { parseDate } from 'chrono-node';
import dayjs from 'dayjs';

export type TDateRange = {
  from: LWTDate;
  to: LWTDate;
};

export class LWTDate extends Date {
  // TODO (year, month, day)を渡せるように
  constructor(init?: string | number | Date) {
    super();
    if (typeof init === 'string') {
      if (parseDate(init)) {
        this.setTime(parseDate(init).getTime());
      }
      return;
    }
    if (typeof init === 'number') {
      this.setTime(init);
      return;
    }
    if (init) this.setTime(init.getTime());
  }
  static formatToday = (): string => new LWTDate().formatYMDForApi();

  difInYear = (date: LWTDate): number => Math.floor((date.getTime() - this.getTime()) / 1000 / 60 / 60 / 24 / 365);
  format = (format: string): string => dayjs(this).locale('ja').format(format);
  formatYMDForApi = (): string => this.format('YYYY-MM-DD');
  toGMTString = (): string => dayjs(this).locale('en').format('ddd, DD MMM YYYY HH:mm:ss G[M]T;');
}
